import React from 'react'
import { Container,Row, Col} from 'react-bootstrap'
import '../../style/package.scss'
import Card from  '../../components/Packages/Cards'
import green from '../../assets/pkg-bg/Group 476.png'
import yellow from '../../assets/pkg-bg/Group 477.png'
import pink from '../../assets/pkg-bg/Group 478.png'
import Parallax from 'react-rellax'
import { useHistory } from 'react-router-dom'

var sessionstorage = require('sessionstorage');

console.log("this is the final token",sessionstorage.getItem('token'));

export default function Index() {

    let history = useHistory();

    return (
        <>
        {/* <section id='package1'>
            
        <section>
        <div class="main-pakages-div">
            <div class="pakage-div-one">
                <h1>Packages</h1>
            </div>
            <div class="package-wrap pakage-div-two">
                <div class="package">
                    <div class="img-div">
                        <h4>Standard SMM Packages</h4>
                        <img src={require('../../assets/images/pakage_card-1.png')} alt="" />
                    </div>
                    <div class="content-div">
                        
                        <ul className='bullets'>
                            <li><i class="fa fa-check-circle"></i> For Up To 2 Social Media Platforms</li>
                            <li><i class="fa fa-check-circle"></i>3 Post Per Week</li>
                            <li><i class="fa fa-check-circle"></i>All Images, Graphics And CopyWriting Included. Featured
                                Videos Available</li>
                            <li><i class="fa fa-check-circle"></i>Messaging And Comment Moderation Included</li>
                            <li><i class="fa fa-check-circle"></i>Boosted Post Add-On Available</li>
                        </ul>
                    </div>
                    {sessionstorage.getItem('token') ===null ?(
                        <>
                    <button onClick={()=>redirecttoList("std")}>Register</button>
                    </>
                    ):(
                        <>
                    <button onClick={()=>history.push('/standard-list')}>Buy</button>
                    </>
                    )
                    }
                </div>
            </div>
            <div class="package-wrap pakage-div-three">
                <div class="package">
                    <div class="img-div">
                        <h4>Custom SMM Packages</h4>
                        <img src={require('../../assets/images/pakge_card.png')} alt="" />
                    </div>
                    <div class="content-div">
                        <ul className='bullets'>
                            <li><i class="fa fa-check-circle"></i>For Up To 2 Social Media Platforms</li>
                            <li><i class="fa fa-check-circle"></i>3 Post Per Week</li>
                            <li><i class="fa fa-check-circle"></i>All Images, Graphics And CopyWriting Included. Featured
                                Videos Available</li>
                            <li><i class="fa fa-check-circle"></i>Messaging And Comment Moderation Included</li>
                            <li><i class="fa fa-check-circle"></i>Boosted Post Add-On Available</li>
                        </ul>
                    </div>
                    {sessionstorage.getItem('token') ===null ?(
                        <>
                    <button onClick={()=> redirecttoList("custom")}>Register</button>
                    </>
                    ):(
                        <>
                    <button onClick={()=>history.push('/customized-list')}>Buy</button>
                    </>
                    )
                    }
                </div>
            </div>
            
        </div>
    </section>
    </section> */}

    {/* packages */}

<div class="section" id="packages">
	<div>
	<h1>Packages</h1>
        <div class="main-packages">
            <div class="package-wrap">
                <div class="package">
                    <h4>Standard</h4>
                    <div class="content" id="style-4">
                        <ul>
                            <li><i class="fa fa-check-circle"></i>Sunday Livestreaming on ROKU, AppleTV, Amazon Fire TV & website</li>
                            <li><i class="fa fa-check-circle"></i>3-5 programs during week days, Mon-Sat, 30-60 mins</li>
                            <li><i class="fa fa-check-circle"></i>$199/mo</li>
                            <li><i class="fa fa-check-circle"></i>No set up fee</li>   
                            <li><i class="fa fa-check-circle"></i>Cancel anytime</li>                            
                        </ul>
                    </div>
                    <div align="center">
                    {sessionstorage.getItem('token') ===null ?(
                        <>
                    <button onClick={()=>redirecttoList("std")}>Sign Up Now</button>
                    </>
                    ):(
                        <>
                    <button onClick={()=>history.push('/standard-list')}>Buy</button>
                    </>
                    )
                    }
                    </div>
                </div>
            </div>
            <div class="package-wrap">
                <div class="package">
                    <h4>Custom</h4>
                    <div class="content" id="style-3">
                        <ul>
                            <li><i class="fa fa-check-circle"></i>Digital Marketing – SEO, SMM, SMO </li>
                            <li><i class="fa fa-check-circle"></i>Content creation – short videos with captions, posters</li>
                            <li><i class="fa fa-check-circle"></i> Posting on your Social Media platforms</li>
                            <li><i class="fa fa-check-circle"></i>  Build beautiful websites</li>
                            <li><i class="fa fa-check-circle"></i>  Fix / Enhance broken websites</li>
                            <li><i class="fa fa-check-circle"></i>  Customized TV programs </li>
                        </ul>
                        <table class="border w-100 mt-2">
                            <th class="border p-2 text-center"><b>Available Slots</b></th>
                            <tr>
                                <td class="border p-2">Buy 24 hour air-time on MyChurchTV</td>
                            </tr>
                            <tr>
                                <td class="border p-2"> Have exclusive VOD section for your ministry</td>
                            </tr>
                           
                        </table>
                    </div>
                    <div align="center">
                    {sessionstorage.getItem('token') ===null ?(
                        <>
                    <button onClick={()=> redirecttoList("custom")}>Register</button>
                    </>
                    ):(
                        <>
                    <button onClick={()=>history.push('/customized-list')}>Buy</button>
                    </>
                    )
                    }
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
        </>
    )

    function redirecttoList(type)
    {
        

        if(type === "std")
        {
            sessionstorage.setItem("list","standard-list");
            history.push('/login/standard-list');
            history.go(0);
        }
        if(type === "custom"){
            sessionstorage.setItem("list","customized-list");
            history.push('/login/customized-list');
            history.go(0);
        }
    }
    
}
